import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get targets() {
        return ["prizeContainer", "prizeImageContainer", "prizeImage", "prizeName", "prizeDescription", "addressContainer"];
    }

    showSelectedPrize({ target }) {
        const selectedOption = target.options[target.selectedIndex];

        if (selectedOption.value) {
            this.prizeContainerTarget.classList.remove("d-none");
            this.prizeImageContainerTarget.classList.toggle("d-none", !selectedOption.dataset.image);
            this.prizeImageTarget.src = selectedOption.dataset.image;
            this.prizeNameTarget.innerHTML = selectedOption.dataset.title;
            this.prizeDescriptionTarget.innerHTML = selectedOption.dataset.description;
        } else {
            this.prizeContainerTarget.classList.add("d-none");
        }
    }

    showAddressContainer({ target }) {
        const selectedOption = target.options[target.selectedIndex];
        this.addressContainerTarget.classList.toggle("d-none", selectedOption.dataset.requiresAddress !== "True");
    }
}